import React, { useEffect } from 'react';
import { useDjAuth } from '../auth/DjAuthContext';
import Loading from '../components/Loading';

const LoginRedirect: React.FC = () => {
  const { djAuth } = useDjAuth();

  useEffect(() => {
    djAuth.login();
  }, []);

  return (
    <div className={`fixed top-0 bottom-0 left-0 right-0 z-[100] px-8 py-10 bg-white`}>
      <div className="h-full flex justify-center items-center">
        <Loading />
      </div>
    </div>
  );
};

export default LoginRedirect;
